import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import total from "../../../../Assets/1.png";
import opening from "../../../../Assets/2.png";
import hired from "../../../../Assets/3.png";
import rejected from "../../../../Assets/4.png";
import "../../../../Assets/css/Jobs/AnalyticsDashboard.css";
import {
  createJob,
  generateAISkills,
  generateJobDescription,
  getCandidates,
  getJobAnalytics,
  getPostedJobs,
  setSelectedApplicantStatus,
  setSelectedCompany
} from "../../../../Redux/Reducers/JobReducer";
import { useProfileContext } from "../../../ProfileDetailContext";
import { useQuantityContext } from "../../../QuantityContext";
import CompanySelectionModal from "../CompanySelectionModal";
import PostingJobModal from "./PostingJobModal";
import {
  getCompanyIdFromUserType,
  getEnterpriseEntityIdFromUserType,
} from "../../../../utils/userTypeUtils";
import { filterCompaniesFromUserType } from "../../../../utils/filterUtil";
import { syncEnterpriseJobAPI } from "../../../../enterpriseApi";
import { getUserIdDetails } from "../../../../Redux/Reducers/OnboardingReducer";

// import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import { Badge } from "@mui/material";
import {
  DateCalendar,
  LocalizationProvider,
  PickersDay,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { offerStatuses } from "../../../Utilities/ListUtils";
import CompanyCalender from "./CompanyCalender";

const timeZones = Intl.supportedValuesOf("timeZone");

// ─── No Data Empty State ────────────────────────────────────────────────────
const NoDataEmptyState = ({ onPostJob }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "85vh",
      backgroundColor: "#ffffff",
      px: 3,
      textAlign: "center",
    }}
  >
    <Box
      sx={{
        width: 96,
        height: 96,
        borderRadius: "24px",
        background: "linear-gradient(135deg, #e8f0fe 0%, #dbeafe 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2.5,
        boxShadow: "0 4px 16px rgba(26,86,219,0.10)",
      }}
    >
      <BarChartRoundedIcon sx={{ fontSize: 52, color: "#1a56db" }} />
    </Box>

    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "#1e293b", mb: 1 }}
    >
      No Data
    </Typography>

    <Typography
      variant="body2"
      sx={{ color: "#64748b", mb: 2, maxWidth: 260, lineHeight: 1.6 }}
    >
      There is no enough data to show.
    </Typography>

    <Typography
      onClick={onPostJob}
      sx={{
        color: "#1a56db",
        fontWeight: 600,
        fontSize: "14px",
        cursor: "pointer",
        mb: 4,
        "&:hover": { textDecoration: "underline" },
      }}
    >
      Post Job
    </Typography>

    <Card
      onClick={onPostJob}
      sx={{
        width: "100%",
        maxWidth: 380,

        p: "14px 24px",
        borderRadius: "14px",
        border: "1.5px solid #e2e8f0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        cursor: "pointer",
        backgroundColor: "#fff",
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: "0 6px 20px rgba(26,86,219,0.14)",
          borderColor: "#1a56db",
          transform: "translateY(-2px)",
        },
      }}
    >
      <AddCircleRoundedIcon sx={{ color: "#1a56db", fontSize: 26 }} />
      <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: "16px" }}>
        Post a new job
      </Typography>
    </Card>
  </Box>
);

const AnalyticsDashboard = () => {
  const companyCalender =
    useSelector((state) => state?.jobs?.companyCalender) || [];
  const selectedCompany =
    useSelector((state) => state?.jobs?.selectedCompany) || {};

  // console.log("selectedCompany123", selectedCompany);

  const jobAnalytics = useSelector((state) => state?.jobs?.jobAnalytics) ?? {
    data: [],
    jobApplicationsStatuswiseCount: {},
    jobOpenCloseCount: {},
  };

  // console.log("jobAnalyticsNNNN", jobAnalytics)

  // console.log("jobAnalytics", jobAnalytics);
  const totalJobs = jobAnalytics?.data?.length || 0;
  const totalApplicants = jobAnalytics?.totalApplications || 0;
  const CloseCount = jobAnalytics?.jobOpenCloseCount?.close_jobs_count ?? "0";
  const OpenCount = jobAnalytics?.jobOpenCloseCount?.open_jobs_count ?? "0";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openSnackbar, handleFailure, handleInfo } = useQuantityContext();
  const [jobPostModal, setJobPostModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [hiringModalOpen, setHiringModalOpen] = useState(false);
  const [hiringInputValue, setHiringInputValue] = useState("");
  const [hiringData, setHiringData] = useState({
    role: "",
    company_name: "",
    company_url: "",
    dept_type: "",
    emp_type: "",
    edu_level: "",
    experience: "",
    salary: "",
    location: "",
    mode: "",
    skills: [],
    candidate_profile: " ",
    job_description_md: "",
    company_location: "",
  });
  const [selectedChips, setSelectedChips] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [generatedDescription, setGeneratedDescription] = useState(null);
  const generatedJobDescriptions = useSelector(
    (state) => state.jobs.generatedJobDescriptions
  );
  const generatedSkills = useSelector((state) => state.jobs?.generatedSkills);
  const [localGeneratedSkills, setLocalGeneratedSkills] =
    useState(generatedSkills);
  const [isLoadingSkills, setIsLoadingSkills] = useState(false);
  const [isLoadingDescription, setIsLoadingDescription] = useState(false);
  const { ExperienceList, setExperienceList } = useProfileContext();
  const [showCompanySelection, setShowCompanySelection] = useState(false);
  const ProfessionalExperience = useSelector(
    (state) => state?.ProfileArray?.experienceData?.data
  );
  const rawUserTypeDetails = useSelector((state) => state?.onboarding?.userTypeDetails);
  const userTypeDetails =
    (rawUserTypeDetails?.data && Array.isArray(rawUserTypeDetails.data))
      ? rawUserTypeDetails.data
      : (Array.isArray(rawUserTypeDetails) ? rawUserTypeDetails : []);

  useEffect(() => {
    if (
      (!userTypeDetails || userTypeDetails.length === 0) &&
      localStorage.getItem("objectId")
    ) {
      dispatch(getUserIdDetails());
    }
  }, [dispatch, userTypeDetails]);

  const enterpriseCompanies = filterCompaniesFromUserType(
    rawUserTypeDetails || userTypeDetails,
    ProfessionalExperience
  );

  const [open, setOpen] = useState(false);
  const [calendarName, setCalendarName] = useState("");
  const [date, setDate] = useState(dayjs());
  const [selectedTimeZone, setSelectedTimeZone] = useState("Asia/Calcutta");
  const [showDayView, setShowDayView] = useState(false);
  const [selectedDateEvents, setSelectedDateEvents] = useState([]);
  const [eventDetailsOpen, setEventDetailsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const departmentData = jobAnalytics.departmentWiseCount || [];
  const totalJobsCount = departmentData.reduce(
    (acc, curr) => acc + curr.jobCount,
    0
  );

  const handleFilterOpen = () => {
    setOpen(true);
  };

  const handleCalenderClose = () => setOpen(false);

  const companyLogo = ProfessionalExperience[0]?.company_logo || "";

  const workingCompanies =
    ProfessionalExperience?.filter(
      (exp) => exp?.is_currently_working == true && exp?.is_verified == true
    ) || null;

  const analyticsCompanies = jobAnalytics?.companiesPostedByUser || [];

  const companies =
    analyticsCompanies?.filter((company) =>
      workingCompanies?.some((c) => c.company_name == company?.company_name)
    ) || [];

  // console.log("companiesNNNNNNN", companies, jobAnalytics, workingCompanies)

  useEffect(() => {
    setLocalGeneratedSkills(generatedSkills);
  }, [generatedSkills]);

  const handleHiringModalClose = () => {
    setHiringModalOpen(false);
    setCurrentStep(1);
    setHiringData({
      role: "",
      dept_type: "",
      emp_type: "",
      edu_level: "",
      experience: "",
      salary: "",
      location: "",
      mode: "",
      skills: [],
      candidate_profile: " ",
      job_summary: "",
      qualifications: [],
      responsibility: [],
      about_company: "",
      // company_location: "",
    }); // Reset form data when closing
  };

  const matchedCompanies = analyticsCompanies?.filter(jobCompany => {
    return ProfessionalExperience?.some(exp =>
      exp?.company_name?.toLowerCase() === jobCompany?.company_name?.toLowerCase() &&
      exp?.is_currently_working === true &&
      exp?.is_verified === true
    );
  }) || []

  useEffect(() => {
    // Get only currently working experiences
    const currentExperiences =
      ProfessionalExperience?.filter(
        (exp) => exp?.is_currently_working && exp?.is_verified
      ) || [];

    if (!currentExperiences || currentExperiences?.length == 0) {
      openSnackbar(
        "You need to be verified and currently employed to post a job",
        "warning"
      );
      handleHiringModalClose();
      return;
    }

    // Set hiring data from current experience
    if (currentExperiences?.length > 0) {
      const currentExp = currentExperiences[0]; // Get the first current experience
      setHiringData((prev) => ({
        ...prev,
        company_name: currentExp?.company_name || "",
        about_company: currentExp?.about_company || "",
        company_url: currentExp?.company_domain || "",
        emp_type: currentExp?.employee_type || "",
        mode: currentExp?.location_type || "",
        company_location: currentExp?.location || "",
        company_logo: currentExp?.company_logo || "", // Add company logo
      }));
    }
  }, [ProfessionalExperience, navigate]);


  // Add these menu options
  const menuOptions = {
    "Department Type": [
      "Human Resources (HR)",
      "Finance & Accounting",
      "Marketing",
      "Sales",
      "Customer Support",
      "Operations",
      "Legal & Compliance",
      "Administrative",
      "Information Technology (IT)",
      "Software Development",
      "Data & Analytics",
      "Product Management",
      "Medical & Clinical",
      "Pharmacy",
      "Research & Development (R&D)",
      "Production & Manufacturing",
      "Engineering",
      "Quality Assurance (QA)",
      "Academic Affairs",
      "Student Affairs",
      "Training & Development",
      "Public Relations (PR)",
      "Procurement & Purchasing",
      "Supply Chain & Logistics",
    ],
    "Employment Type": [
      "Full-time/ Permanent",
      "Part-time",
      "Freelance",
      "Internship",
      "Trainee",
    ],
    "Education Type": [
      "Undergraduate",
      "10th/SSLC/SCC",
      "12th/PUC/HSC",
      "Postgraduate",
      "Higher Education",
      "Any Graduate",
    ],
    "Experience Range": [
      "Fresher/No Experience",
      "0-1 Year",
      "1-3 Years",
      "3-5 Years",
      "5-7 Years",
      "7-10 Years",
      "10-15 Years",
      "15+ Years",
    ],
    "Salary Range": [
      "Less than 2,00,000",
      "2,00,000-5,00,000",
      "5,00,000-10,00,000",
      "10,00,000-15,00,000",
      "15,00,000-20,00,000",
      "20,00,000-30,00,000",
      "35,00,000-50,00,000",
      "50,00,000-1,00,00,000",
      "Above-1,00,00,000",
    ],
    "Work Location": ["Bangalore", "Hyderabad", "Chennai", "Delhi", "Kochi"],
    "Work Mode": ["On-site", "Hybrid", "Remote"],
  };
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");

  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  useEffect(() => {
    if (
      selectedCompany?.company_name &&
      companies?.some(
        (company) => company.company_name === selectedCompany.company_name
      )
    ) {
      dispatch(getJobAnalytics({ company: selectedCompany?.company_name }));
    } else if (companies?.length > 0) {
      dispatch(setSelectedCompany(companies[0]));
      dispatch(getJobAnalytics({ company: companies[0]?.company_name }));
    }
  }, [selectedCompany]);


  const handleHiringAddChip = (newChip) => {
    if (newChip && !localGeneratedSkills.includes(newChip)) {
      setLocalGeneratedSkills([...localGeneratedSkills, newChip]); // Add new skill to local state
      setHiringInputValue("");
    }
  };

  const handleChipToggle = (chip) => {
    const updatedChips = selectedChips.includes(chip)
      ? selectedChips.filter((item) => item !== chip)
      : [...selectedChips, chip];

    setSelectedChips(updatedChips);
    setHiringData((prev) => ({ ...prev, skills: updatedChips }));
  };

  const handleHiringChipDelete = (chip) => {
    setLocalGeneratedSkills((prev) => prev.filter((item) => item !== chip));
    setSelectedChips((prev) => prev.filter((item) => item !== chip));
    setHiringData((prev) => ({ ...prev, skills: selectedChips }));
  };

  const handleEditResponseClick = () => {
    setCurrentStep(4);
  };

  const handleEditSkillClick = () => {
    setCurrentStep(1);
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const barData = departmentData.map((dept) => ({
    label: dept.dept_type,
    screen: "FilteredJobs",
    routes: { departmentName: dept.dept_type },
    value: dept.jobCount,
    percentage:
      totalJobsCount > 0
        ? Math.round((dept.jobCount / totalJobsCount) * 100)
        : 0,
  }));

  // console.log("barDataMMMMM", barData)

  const handleStatusClick = (status) => {
    // dispatch(getJobAnalytics());
    // const offerStatus ='Offer Released|Offer Accepted|Offer Revised|Offer Declined|Offer Revoked'
    let AppStatus = status;
    if (status == "all") {
      AppStatus = "";
    } else if (status == "offer") {
      AppStatus = offerStatuses?.join("|");
    }

    const payload =
      status === "all"
        ? { company: selectedCompany?.company_name }
        : { company: selectedCompany?.company_name, status: AppStatus };

    dispatch(setSelectedApplicantStatus(AppStatus));
    dispatch(getCandidates(payload));
    dispatch(getPostedJobs({ company: selectedCompany?.company_name }));
    navigate({
      pathname: "/candidate-progress",
      // search: createSearchParams({
      //   status: status,
      // }).toString(),
    });
  };

  const handleJobsClick = () => {
    dispatch(getPostedJobs({ company: selectedCompany?.company_name }));
    navigate({
      pathname: "/alljobs",

      // search: createSearchParams({
      //   status: status,
      // }).toString(),
    });
  };

  const handleHiringSubmit = async () => {
    try {
      const errors = {};
      let errorMessage = "";

      if (Object.keys(errors).length > 0) {
        // Remove trailing comma and space
        errorMessage = errorMessage.slice(0, -2);
        // handleInfo(`Please fill in the following fields: ${errorMessage}`);

        // Update UI to show red borders (you'll need to add this state to your component)
        // setFieldErrors(errors);
        return;
      }


      // Validate fields
      const isDataComplete = Object.values(hiringData).every((field) => {
        return (
          field !== null &&
          field !== "" &&
          !(Array.isArray(field) && field.length === 0)
        );
      });

      // if (!isDataComplete) {
      //   console.log("INCOMPLETE HIRING DATA:", hiringData);
      //   alert("Please fill all the fields before submitting.");
      //   return;
      // }

      // ✅ Format the data properly
      const companyId =
        hiringData.company_id ||
        getCompanyIdFromUserType(userTypeDetails, hiringData.company_name);

      const formattedHiringData = {
        ...hiringData,
        company_id: companyId || hiringData.company_id || undefined,
        skills_required: JSON.stringify(hiringData.skills),
        responsibility: JSON.stringify(hiringData.responsibility),
        qualifications: JSON.stringify(hiringData.qualifications),
        perks: JSON.stringify(hiringData.perks),
        pre_requisites: JSON.stringify(hiringData.pre_requisites),
        no_of_open_positions: Number(hiringData.no_of_open_positions),
      };

      // ✅ Dispatch the action instead of making a direct API call
      const response = await dispatch(createJob(formattedHiringData));

      if (
        response?.payload?.statusCode == 201 ||
        response?.payload?.statusCode == 200 ||
        response?.payload?.success === true
      ) {
        // Sync created job with Enterprise service
        const createdJobId =
          response?.payload?.data?.id ||
          response?.payload?.data?.jobId ||
          response?.payload?.data?.job_id ||
          response?.payload?.id ||
          response?.payload?.jobId ||
          (typeof response?.payload?.data === "number" ? response?.payload?.data : null);

        const enterpriseCompanyId =
          hiringData.enterprise_company_id ||
          getEnterpriseEntityIdFromUserType(
            userTypeDetails,
            hiringData.company_name || companyId
          );

        if (createdJobId && enterpriseCompanyId) {
          try {
            await syncEnterpriseJobAPI({
              jobId: createdJobId,
              companyId: enterpriseCompanyId,
              jobtype: hiringData.emp_type || "full-time/permanent",
            });
          } catch (syncErr) {
            console.error("Error syncing job with enterprise service:", syncErr);
          }
        }

        // handleSuccess("Job posting created successfully!");
        handleHiringModalClose();
        setHiringData("");
        setLocalGeneratedSkills("");
        setCurrentStep(1);
        dispatch(getPostedJobs({ company: selectedCompany?.company_name }));
      } else {
        // handleFailure("Failed to create job posting");
      }
    } catch (error) {
      console.error("Error submitting hiring data:", error.message);
      handleFailure(
        "Error submitting hiring data. Please check the console for details."
      );
    }
  };

  const stats = [
    {
      label: "Total Jobs",
      value: totalJobs,
      image: total,
      // onClick: () => navigate("/alljobs"),
      onClick: () => handleJobsClick(),
    },
    {
      label: "Total Applicants",
      // value: totalApplicants,
      value: (jobAnalytics && jobAnalytics?.totalApplications) || 0,
      image: opening,
      // onClick: () => navigate("/candidate-progress"),
      onClick: () => handleStatusClick("all"),
    },
    {
      label: "No. of In Review",
      value:
        (jobAnalytics &&
          jobAnalytics?.jobApplicationsStatuswiseCount?.["In Review"]) || "0",
      image: hired,
      onClick: () => handleStatusClick("In Review"),
    },
    {
      label: "No. of Shortlisted",
      value:
        (jobAnalytics &&
          jobAnalytics?.jobApplicationsStatuswiseCount?.["Shortlisted"]) || "0",
      image: rejected,
      onClick: () => handleStatusClick("Shortlisted"),
    },
    {
      label: "No. of Selected",
      value:
        (jobAnalytics &&
          jobAnalytics?.jobApplicationsStatuswiseCount?.["Selected"]) ||
        "0",
      image: rejected,
      onClick: () => handleStatusClick("Selected"),
    },
    {
      label: "No. of Offered",
      value: (
        Object.entries(jobAnalytics?.jobApplicationsStatuswiseCount || {})
          .filter(([key]) => typeof key === "string" && key.includes("Offer"))
          .reduce((acc, [, value]) => acc + Number(value || 0), 0)
      ).toString() || "0",
      image: rejected,
      onClick: () => handleStatusClick("offer"),
    },

    {
      label: "No. of Joined",
      value:
        (jobAnalytics &&
          jobAnalytics?.jobApplicationsStatuswiseCount?.["Joined"]) ||
        "0",
      image: rejected,
      onClick: () => handleStatusClick("Joined"),
    },
    {
      label: "No. of Rejected",
      value:
        (jobAnalytics &&
          jobAnalytics?.jobApplicationsStatuswiseCount?.["Rejected"]) ||
        "0",
      image: rejected,
      onClick: () => handleStatusClick("Rejected"),
    },
  ];

  // Horizontal bar chart configuration
  const barChartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const deptType = barData[config.dataPointIndex].label;
          navigate({
            pathname: "/alljobs",
            search: createSearchParams({ dept_type: deptType }).toString(),
          });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40px",
        distributed: true,
        cursor: "pointer",
      },
    },
    dataLabels: { enabled: true }, // Hide labels on bars
    xaxis: {
      categories: barData?.map((item) => item.label),
      labels: { show: false }, // Hide x-axis labels
    },
    yaxis: {
      labels: { show: true }, // Hide y-axis labels
    },
    grid: {
      borderColor: "#e0e0e0",
      yaxis: { lines: { show: true } }, // Remove horizontal grid lines
      xaxis: { lines: { show: false, strokeDashArray: 4, opacity: 0.3 } }, // Keep vertical grid lines
    },
    tooltip: { enabled: true, theme: "light" },
    colors: [
      "#4CAF50",
      "#0088FE",
      "#FF4C61",
      "#4CAF50",
      "#0088FE",
      "#FF4C61",
      "#FFA500",
      "#00ACC1",
      "#808080",
    ],
  };

  const barChartData = [
    {
      data: barData.map((item) => item.value), // Changed from percentage to value
    },
  ];

  const donutChartOptions = {
    chart: {
      type: "donut",
    },
    labels: ["Open Jobs", "Closed Jobs"],
    colors: ["#4CAF50", "#FF4C61"],
    legend: {
      position: "bottom",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 90,
        offsetY: 10,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const value = opts.w.config.series[opts.seriesIndex]; // Get actual value
        return `${value} (${val.toFixed(1)}%)`;
      },
    },
  };

  const handleNext = async () => {
    if (currentStep === 1) {
      const {
        role: role,
        dept_type: departmentType,
        emp_type: employmentType,
        edu_level: education,
        salary: salary,
        experience: experience,
      } = hiringData;
      setIsLoadingSkills(true);
      try {
        await dispatch(
          generateAISkills({
            role,
            departmentType,
            employmentType,
            education,
            salaryRange: salary,
            experienceRange: experience,
          })
        );
      } finally {
        setIsLoadingSkills(false);
      }
    }
    if (currentStep === 2) {
      // Destructure and rename required fields
      const {
        role: role,
        company_name: companyName,
        dept_type: departmentType,
        emp_type: employmentType,
        edu_level: education,
        location: jobLocation,
        mode: mode,
        skills: keySkills,
      } = hiringData;

      // Create payload with required structure
      const generationPayload = {
        role,
        companyName,
        departmentType,
        employmentType,
        education,
        jobLocation,
        mode,
        keySkills,
        roleCategory: null, // Add default null value for this field
      };
      setIsLoadingDescription(true);

      try {
        const result = await dispatch(
          generateJobDescription(generationPayload)
        );
        if (result?.payload) {
          setHiringData((prev) => ({
            ...prev,
            // about_company: result?.payload?.data?.about_company,
            job_description_md: result?.payload
          }));
        }
      } finally {
        setIsLoadingDescription(false);
      }
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const currentExperiences =
    ProfessionalExperience?.filter(
      (exp) => exp.is_currently_working && exp.is_verified
    ) || [];

  const displayCompanies =
    enterpriseCompanies.length > 0 ? enterpriseCompanies : currentExperiences;

  const handlePostJobClick = () => {
    if (displayCompanies.length > 0) {
      setShowCompanySelection(true);
    } else {
      openSnackbar(
        "You need to be verified and currently employed to post a job",
        "warning"
      );
      // navigate("/myprofile");
    }
  };

  const handleClose = () => {
    if (!isLoadingSkills && !isLoadingDescription) {
      handleHiringModalClose();
      setCurrentStep(1);
      setHiringData({
        role: "",
        dept_type: "",
        emp_type: "",
        edu_level: "",
        experience: "",
        salary: "",
        location: "",
        mode: "",
        skills: [],
        candidate_profile: " ",
        job_summary: "",
        qualifications: [],
        responsibility: [],
        about_company: "",
        // company_location: "",
      });
    }
  };

  const handleHiringInputChange = (e) => {
    // e.preventDefault();
    const { name, value } = e.target;
    // console.log("handleHiring", name, value);

    if (name === "responsibility" || name === "qualifications") {
      setHiringData((prev) => ({ ...prev, [name]: value.split("\n") }));
    } else {
      setHiringData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // const handleKeyDown = (e) => {
  // };

  const handleCompanySelection = (selectedExperience) => {
    const companyId =
      selectedExperience.cid ||
      selectedExperience.uniqueId ||
      getCompanyIdFromUserType(
        userTypeDetails,
        selectedExperience.companyName || selectedExperience.company_name
      );
    const enterpriseCompanyId =
      selectedExperience.id ||
      selectedExperience.entityId ||
      getEnterpriseEntityIdFromUserType(
        userTypeDetails,
        selectedExperience.companyName || selectedExperience.company_name || companyId
      );

    const targetCompName = (selectedExperience.companyName || selectedExperience.company_name || "")?.trim()?.toLowerCase();
    const targetCid = (companyId || selectedExperience.cid || selectedExperience.uniqueId || "")?.toString()?.trim()?.toLowerCase();
    const targetLogo = (selectedExperience.companyLogo || selectedExperience.company_logo || "")?.trim();

    const matchedExp = (Array.isArray(ProfessionalExperience) ? ProfessionalExperience : []).find((exp) => {
      const expCid = (exp?.cid || exp?.uniqueId || exp?.company_id || "")?.toString()?.trim()?.toLowerCase();
      const expName = (exp?.company_name || exp?.companyName || "")?.trim()?.toLowerCase();
      const expLogo = (exp?.company_logo || exp?.companylogo?.data || "")?.toString()?.trim();

      if (expCid && targetCid && expCid === targetCid) return true;
      if (expName && targetCompName && expName === targetCompName) return true;
      if (expLogo && targetLogo && expLogo === targetLogo) return true;
      if (expName && targetCompName && (expName.includes(targetCompName) || targetCompName.includes(expName))) return true;
      return false;
    });

    let companyDomain =
      selectedExperience.company_domain ||
      selectedExperience.companyDomain ||
      selectedExperience.company_url ||
      selectedExperience.website ||
      matchedExp?.company_domain ||
      matchedExp?.companyDomain ||
      matchedExp?.website ||
      matchedExp?.company_url ||
      hiringData?.company_url ||
      "";

    if (!companyDomain && matchedExp?.company_email && matchedExp.company_email.includes("@")) {
      const emailDomain = matchedExp.company_email.split("@")[1]?.trim()?.toLowerCase();
      const publicProviders = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com"];
      if (emailDomain && !publicProviders.includes(emailDomain)) {
        companyDomain = emailDomain;
      }
    }

    setHiringData((prev) => ({
      ...prev,
      company_name: selectedExperience.companyName || selectedExperience.company_name || "",
      company_url: companyDomain || prev?.company_url || "",
      company_location: selectedExperience.location || matchedExp?.location || prev?.company_location || "",
      emp_type: selectedExperience.employee_type || selectedExperience.role || matchedExp?.employee_type || prev?.emp_type || "",
      mode: selectedExperience.location_type || selectedExperience.location || matchedExp?.location_type || "Remote",
      company_logo: selectedExperience.companyLogo || selectedExperience.company_logo || matchedExp?.company_logo || "", // Add company logo
      company_id: companyId || "",
      enterprise_company_id: enterpriseCompanyId || undefined,
    }));
    setShowCompanySelection(false);
    setHiringModalOpen(true);
  };


  const handleJobStatusClick = (status) => {
    navigate({
      pathname: "/alljobs",
      search: createSearchParams({
        status: status,
      }).toString(),
    });
  };

  const handleCompanySelect = (company) => {
    // console.log("calendarNameNNN", company);
    dispatch(getJobAnalytics({ company: company?.company_name }));
    dispatch(getPostedJobs({ company: company?.company_name }));
    // setSelectedCompany(company);
    dispatch(setSelectedCompany(company));
    setOpen(false);
  };

  // Add this handler for date selection
  const handleDateSelection = (newValue) => {
    setDate(newValue);
    const selectedDay = newValue.format("YYYY-MM-DD");

    const dayEvents = companyCalender.filter(
      (event) => dayjs(event.startTime).format("YYYY-MM-DD") === selectedDay
    );

    if (dayEvents.length === 1) {
      setSelectedEvent(dayEvents[0]);
      setEventDetailsOpen(true);
    } else if (dayEvents.length > 1) {
      setSelectedDateEvents(dayEvents);
      setShowDayView(true);
    }
  };

  const getTimeSlots = () => {
    const slots = [];
    for (let i = 0; i < 24; i++) {
      slots.push(dayjs().hour(i).minute(0));
    }
    return slots;
  };

  const calculateEventPosition = (event, allEvents, slotEvents) => {
    // Find events that overlap with the current event
    const overlappingEvents = slotEvents.filter((e) => {
      const eventStart = dayjs(event?.startTime);
      const eventEnd = dayjs(event?.endTime);
      const eStart = dayjs(e?.startTime);
      const eEnd = dayjs(e?.endTime);

      // Check if events overlap
      return (
        (eventStart.isBefore(eEnd) && eventEnd.isAfter(eStart)) ||
        (eStart.isBefore(eventEnd) && eEnd.isAfter(eventStart))
      );
    });

    // Sort overlapping events by start time and duration
    overlappingEvents.sort((a, b) => {
      const startDiff = dayjs(a.startTime).diff(dayjs(b.startTime));
      if (startDiff === 0) {
        return (
          dayjs(b.endTime).diff(dayjs(b.startTime)) -
          dayjs(a.endTime).diff(dayjs(a.startTime))
        );
      }
      return startDiff;
    });

    // Find position of current event in overlapping events
    const position = overlappingEvents.indexOf(event);
    const total = overlappingEvents.length;

    return { position, total };
  };

  const DayViewTimeGrid = ({ events, date }) => {
    const timeSlots = getTimeSlots();
    const [modalEvent, setModalEvent] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    const handleEventClick = (event) => {
      setModalEvent(event);
      setModalOpen(true);
    };

    return (
      <Box sx={{ height: "600px", overflow: "auto" }}>
        {timeSlots?.map((slot) => {
          const slotEvents = events?.filter(
            (event) => dayjs(event?.startTime).hour() === slot.hour()
          );

          return (
            <Box
              key={slot.format("HH:mm")}
              sx={{
                display: "flex",
                borderBottom: "1px solid #eee",
                minHeight: "60px",
              }}
            >
              <Box
                sx={{
                  width: "60px",
                  p: 1,
                  borderRight: "1px solid #eee",
                  color: "text.secondary",
                  fontSize: "12px",
                }}
              >
                {slot.format("hh:mm A")}
              </Box>
              <Box sx={{ flex: 1, position: "relative" }}>
                {slotEvents?.map((event, index) => {
                  const { position, total } = calculateEventPosition(
                    event,
                    events,
                    slotEvents
                  );
                  const width = `${100 / total}%`;
                  const left = `${(position * 100) / total}%`;

                  return (
                    <Card
                      key={index}
                      onClick={() => handleEventClick(event)}
                      sx={{
                        position: "absolute",
                        left: left,
                        width: width,
                        m: 0.5,
                        p: 2,
                        backgroundColor: "#e3f2fd",
                        border: "1px solid #90caf9",
                        height: `${(dayjs(event?.endTime).diff(
                          dayjs(event?.startTime),
                          "minute"
                        ) /
                          60) *
                          60
                          }px`,
                        overflow: "hidden",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          zIndex: 1,
                          transform: "scale(1.02)",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: total > 1 ? "column" : "row",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {event?.title}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {event?.interviewType}
                        </Typography>
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{
                          mr: 1,
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {dayjs(event?.startTime).format("hh:mm A")} -{" "}
                        {dayjs(event?.endTime).format("hh:mm A")}
                      </Typography>
                    </Card>
                  );
                })}
              </Box>
            </Box>
          );
        })}

        <EventDetailsModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          event={modalEvent}
        />
      </Box>
    );
  };

  const EventDetailsModal = ({ open, onClose, event }) => {
    if (!event) return null;

    return (
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" gutterBottom>
            {event?.title}
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" color="text.secondary">
              Interview Type: {event?.interviewType}
            </Typography>

            <Typography variant="body2" sx={{ mt: 1 }}>
              Time: {dayjs(event?.startTime).format("hh:mm A")} -{" "}
              {dayjs(event?.endTime).format("hh:mm A")}
            </Typography>

            <Typography variant="body2" sx={{ mt: 1 }}>
              Duration: {event?.duration} minutes
            </Typography>

            {event?.description && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Description: {event?.description}
              </Typography>
            )}

            <Typography variant="body2" sx={{ mt: 1 }}>
              Attendees:
            </Typography>
            <Box sx={{ ml: 2 }}>
              {event.attendees.map((attendee, index) => (
                <Typography key={index} variant="body2">
                  • {attendee}
                </Typography>
              ))}
            </Box>

            {event?.meet_link && (
              <Button
                variant="contained"
                href={event?.meet_link}
                target="_blank"
                rel="noopener"
                sx={{ mt: 2 }}
                startIcon={<VideocamRoundedIcon />}
              >
                Join Meeting
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    );
  };

  return (
    <Box className="job-dashboard-container">
      <Box className="job-dashboard-left">
        {totalJobs === 0 ? "" : <Box className="dashboard-header">
          <Typography className="dashboard-title">
            Recruitment Dashboard
          </Typography>
          <Box className="calendar-section">
            {selectedCompany && (
              <Button
                variant="outline"
                sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}
                onClick={handleFilterOpen}
              >
                <img
                  src={
                    selectedCompany?.logo ||
                    "https://i.pinimg.com/736x/ec/d9/c2/ecd9c2e8ed0dbbc96ac472a965e4afda.jpg"
                  }
                  alt="Company Logo"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "#0044C6",
                    fontSize: "18px",
                    minWidth: 100,
                  }}
                >
                  {selectedCompany?.company_name}
                </Typography>
              </Button>
            )}
          </Box>
        </Box>}

        {/* Conditional: No Data Empty State OR Dashboard Content */}
        {totalJobs === 0 ? (
          <NoDataEmptyState onPostJob={handlePostJobClick} />
        ) : (
          <>
            {/* Statistics Cards */}
            <Grid container spacing={3}>
              {stats?.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card className="stat-card" onClick={stat.onClick}>
                    <Box className="stat-card-content">
                      <Typography variant="h5" className="stat-value">
                        {stat.value}
                      </Typography>
                      <img
                        src={stat?.image}
                        alt={stat?.label}
                        style={{ width: "50px" }}
                      />
                    </Box>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                      className="stat-label"
                    >
                      {stat?.label}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>

            {/* Charts Section */}
            <Grid container spacing={3} mt={3}>
              {/* Job Categories Bar Chart */}
              <Grid item xs={12} md={6}>
                <Card className="job-status-card">
                  <Typography variant="h6" className="chart-title" gutterBottom>
                    Job Categories
                  </Typography>
                  <Box
                    sx={{
                      width: '100%',
                      overflowX: 'auto',
                      overflowY: 'hidden',
                      '&::-webkit-scrollbar': {
                        height: '8px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#c1c1c1',
                        borderRadius: '4px',
                        '&:hover': {
                          background: '#a8a8a8',
                        },
                      },
                    }}
                  >
                    <Box sx={{ minWidth: `${barData.length * 80}px` }}>
                      <Chart
                        options={barChartOptions}
                        series={barChartData}
                        type="bar"
                        height={350}
                      />
                    </Box>
                  </Box>
                </Card>
              </Grid>

              {/* Job Status Section */}
              <Grid item xs={12} md={6}>
                <Card className="job-status-card">
                  <Box textAlign={"left"}>
                    <Typography variant="h6" className="job-status-title">
                      Job Status
                    </Typography>
                  </Box>
                  <Box className="job-status-container">
                    <Box textAlign="center">
                      <Box
                        position="relative"
                        display="inline-flex"
                        sx={{
                          background: "#d8f5ff",
                          borderRadius: "50%",
                          padding: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleJobStatusClick("open")}
                      >
                        <CircularProgress
                          variant="determinate"
                          value={
                            (parseInt(OpenCount) /
                              (parseInt(OpenCount) + parseInt(CloseCount))) *
                            100 || 0
                          }
                          size={120}
                          thickness={4}
                          sx={{ color: "#0078D4" }}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{ color: "#0078D4", fontWeight: "bold" }}
                          >
                            {OpenCount}
                          </Typography>
                        </Box>
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "#0078D4", mt: 2, fontWeight: "bold" }}
                      >
                        Open Jobs
                      </Typography>
                    </Box>

                    {/* Closed Jobs */}
                    <Box textAlign="center">
                      <Box
                        position="relative"
                        display="inline-flex"
                        sx={{
                          background: "#ffebee",
                          borderRadius: "50%",
                          padding: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleJobStatusClick("close")}
                      >
                        <CircularProgress
                          variant="determinate"
                          value={
                            (parseInt(CloseCount) /
                              (parseInt(OpenCount) + parseInt(CloseCount))) *
                            100 || 0
                          }
                          size={120}
                          thickness={4}
                          sx={{ color: "#FF4C61" }}
                        />
                        <Box
                          sx={{
                            top: 0,
                            left: 0,
                            bottom: 0,
                            right: 0,
                            position: "absolute",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{ color: "#FF4C61", fontWeight: "bold" }}
                          >
                            {CloseCount}
                          </Typography>
                        </Box>
                      </Box>
                      <Typography
                        variant="h6"
                        sx={{ color: "#FF4C61", mt: 2, fontWeight: "bold" }}
                      >
                        Closed Jobs
                      </Typography>
                    </Box>
                  </Box>
                </Card>
                <Box sx={{ mt: 3, cursor: "pointer" }} onClick={handlePostJobClick}>
                  <Card
                    sx={{
                      p: 3,
                      boxShadow: 3,
                      borderRadius: "16px",
                      textAlign: "center",
                      height: "120px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "#f8faff",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        bgcolor: "#eef2ff",
                        boxShadow: 6,
                        transform: "scale(1.02)",
                        border: "2px solid #0044C6",
                      },
                    }}
                  >
                    <AddCircleRoundedIcon
                      sx={{ color: "#0044C6", fontSize: "32px", mb: 1 }}
                    />
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "#0044C6",
                        fontSize: "18px",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Post a New Job
                    </Typography>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </Box>

      <CompanySelectionModal
        open={showCompanySelection}
        onClose={() => setShowCompanySelection(false)}
        companies={displayCompanies}
        experiences={displayCompanies}
        onSelectCompany={handleCompanySelection}
      />

      <PostingJobModal
        open={hiringModalOpen}
        onClose={handleClose}
        currentStep={currentStep}
        hiringData={hiringData}
        companyLogo={companyLogo}
        menuOptions={menuOptions}
        hiringInputValue={hiringInputValue}
        localGeneratedSkills={localGeneratedSkills}
        selectedChips={selectedChips}
        isLoadingSkills={isLoadingSkills}
        isLoadingDescription={isLoadingDescription}
        handleHiringModalClose={handleHiringModalClose}
        handleHiringInputChange={handleHiringInputChange}
        // handleKeyDown={handleKeyDown}
        handleHiringAddChip={handleHiringAddChip}
        handleChipToggle={handleChipToggle}
        handleHiringChipDelete={handleHiringChipDelete}
        handleEditSkillClick={handleEditSkillClick}
        handleEditResponseClick={handleEditResponseClick}
        handleBack={handleBack}
        handleNext={handleNext}
        handleClose={handleClose}
        handleHiringSubmit={handleHiringSubmit}
        setHiringInputValue={setHiringInputValue}
        setCurrentStep={setCurrentStep}
      />

      <Modal open={open} onClose={handleCalenderClose}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          {companyCalender && companyCalender?.length > 0 ? (
            <Card
              sx={{
                p: 2,
                overflow: "hidden",
                minWidth: showDayView ? 800 : 400,
                maxHeight: "90vh",
                position: "relative",
              }}
            >
              <IconButton
                onClick={handleCalenderClose}
                sx={{ position: "absolute", top: 10, right: 10 }}
              >
                <CloseIcon />
              </IconButton>
              {showDayView ? (
                <Box>
                  <Box display="flex" alignItems="center" mb={2}>
                    <IconButton onClick={() => setShowDayView(false)}>
                      <ArrowBackIosRoundedIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ ml: 1 }}>
                      {date.format("MMMM D, YYYY")}
                    </Typography>
                  </Box>
                  <DayViewTimeGrid events={selectedDateEvents} date={date} />
                </Box>
              ) : (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={date}
                    onChange={handleDateSelection}
                    slots={{
                      day: (props) => {
                        const eventsOnDay = companyCalender?.filter(
                          (event) =>
                            dayjs(event.startTime).format("YYYY-MM-DD") ===
                            props.day.format("YYYY-MM-DD")
                        );

                        return (
                          <Badge
                            key={props.day.toString()}
                            overlap="circular"
                            badgeContent={
                              eventsOnDay?.length > 0 ? (
                                <Box
                                  sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: "50%",
                                    backgroundColor: "#1976d2",
                                  }}
                                />
                              ) : null
                            }
                          >
                            <PickersDay {...props} />
                          </Badge>
                        );
                      },
                    }}
                  />
                </LocalizationProvider>
              )}
            </Card>
          ) : (
            <Card sx={{ p: 3, minWidth: 600, position: "relative" }}>
              <IconButton
                onClick={handleCalenderClose}
                sx={{ position: "absolute", top: 10, right: 10 }}
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6">Select Company</Typography>
              {matchedCompanies?.length > 0 ? (
                <Box sx={{ mt: 2 }}>
                  {matchedCompanies?.map((company, index) => (
                    <Card
                      key={index}
                      onClick={() => handleCompanySelect(company)}
                      sx={{
                        cursor: "pointer",
                        border:
                          selectedCompany?.company_name === company?.company_name
                            ? "2px solid #0044C6"
                            : "1px solid #e0e0e0",
                        p: 2,
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: 3,
                          backgroundColor: "#f8f9fa",
                        },
                      }}
                    >
                      <img
                        src={
                          company?.logo
                            ? company?.logo
                            : "https://i.pinimg.com/736x/ec/d9/c2/ecd9c2e8ed0dbbc96ac472a965e4afda.jpg"
                        }
                        alt={company?.company_name}
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: "50%",
                          marginRight: 16,
                          objectFit: "cover",
                        }}
                      />
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography
                          variant="subtitle1"
                          fontWeight="600"
                          sx={{
                            color:
                              calendarName === company?.company_name
                                ? "#0044C6"
                                : "text.primary",
                          }}
                        >
                          {company?.company_name}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: "#e3f2fd",
                              px: 1,
                              borderRadius: 1,
                              color: "#0044C6",
                            }}
                          >
                            {company?.jobs_posted_count} Jobs Posted
                          </Box>
                        </Typography>
                      </Box>
                    </Card>
                  ))}
                </Box>
              ) : (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 2 }}
                >
                  No companies available for selection.
                </Typography>
              )}
              <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                <Button variant="outlined" onClick={handleCalenderClose}>
                  Cancel
                </Button>
              </Box>
            </Card>
          )}
        </Box>
      </Modal>

      <EventDetailsModal
        open={eventDetailsOpen}
        onClose={() => setEventDetailsOpen(false)}
        event={selectedEvent}
      />

      <Box sx={{ width: "30%", p: 1, backgroundColor: "#f8f9fa" }}>
        <Card sx={{ p: 2, backgroundColor: "#fff" }}>
          <CompanyCalender companyName={selectedCompany?.company_name} />
        </Card>
      </Box>
    </Box>
  );
};

export default AnalyticsDashboard;